import AxiosService from "./axiosServices";
// const axiosService = new AxiosService();

export default class processService {
  getHeaders = () => {
    return {
      headers: {
        "content-Type": "Application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: localStorage.getItem("token"),
      },
    };
  };

  getAuditList = (params) => {
    return AxiosService.Get(`api/cam/pc/process-audit-trail-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

 
}
